import { Component, Input, AfterViewChecked, ChangeDetectorRef, NgZone, ElementRef, TemplateRef } from '@angular/core';
import { HeaderConfig } from './header-config';
import { TranslationStore } from '../translation/translation';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { PersonalData } from '../shoppingcart/contact/personal-data';
import { LoginService } from '../login/login.service';
import { NavigationMenuItem } from '../public-api';

@Component({
    selector: 'pw-headermodule',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewChecked {

    @Input() hasLanguageSelector = true;

    @Input() isRegenero= false;

    @Input() colorOfMobileSidenav = ''

    @Input() hasLogo = true;

    @Input() hasSearchBar = true;

    @Input() facebookURL = '';

    @Input() facebookImgUrl = '';

    @Input() logoUrl = '';

    @Input() hasShoppingCart = true;

    @Input() hasLogin = true;

    @Input() hasAdmin= false;

    @Input() colorOfNavBar = 'green';

    @Input() hasAdminLogo = false;

    @Input() hasFacebookIcon = false;

    @Input() navigationMenu:NavigationMenuItem[] = [];

    @Input() isSubmenuFullScreen = false;

    @Input() hasMatMenu= true;

    @Input() isSideNav = false;

    @Input() dataManagamentUrl = '';

    @Input() aszfUrl = '';

    @Input() isRowView?:boolean;

    @Input() hasMenuTitle = true;

    headerConfig: typeof HeaderConfig = HeaderConfig;

    personalData: PersonalData = {};

    @Input() nameOfTheSite = '';
    @Input() headerTitle = '';
    @Input() logoSize = '';

    dialogConfiger: MatDialogConfig = {
        width: '60%',
        backdropClass: 'back-drop-background',
        hasBackdrop: true
    };
    enterAnimationDuration = '500ms';
    exitAnimationDuration = '200ms';

    showLogin = 'BEJELENTKEZÉS';
    showRegistration = 'REGISZTRÁCIÓ';
    isLoggedIn = false;

    displayLogin = false;

    isExtraSmall: Observable<BreakpointState>;
    isSmall: Observable<BreakpointState>;
    isMedium: Observable<BreakpointState>;

    constructor(
        private readonly breakpointObserver: BreakpointObserver,
        private _matDialog: MatDialog,
        private ref: ChangeDetectorRef,
        private ngZone: NgZone,
        private _router: Router,
        private _loginService:LoginService,
        private elem: ElementRef
    ) {
        this.isExtraSmall= this.breakpointObserver.observe(Breakpoints.XSmall);
        this.isSmall= this.breakpointObserver.observe(Breakpoints.Small);
        this.isMedium = this.breakpointObserver.observe(Breakpoints.Medium);
        this.logoSize= "80px";
        this.elem.nativeElement.style.setProperty('--logo-size', this.logoSize);
    }
    ngAfterViewChecked(): void {
        this.ngZone.runOutsideAngular(() => {
            this.ref.detectChanges();
            setTimeout(() => {
                if (sessionStorage.getItem('token')) {
                    if (this.headerTitle != 'Multiverzum Admin') {
                        this.isLoggedIn = true;
                    }
                } else if (!sessionStorage.getItem('token')) {
                    this.isLoggedIn = false;
                }
                if (sessionStorage.getItem('personalData')) {
                    this.personalData = JSON.parse(sessionStorage.getItem('personalData') as string) as PersonalData;

                }
            }, 0);
        });
    }

    onInit(): void {}

    readTranslations(http: HttpClient, language: string): Observable<TranslationStore> {
        return http.get<TranslationStore>('../header/assets/i18n/' + language + '.json');
    }

    openLogin() {
        this._loginService.openLogin();
    }

    openRegistration() {
        this._loginService.openRegistration();
    }

    showLoginText() {
        this.showLogin = 'Bejelentkezés';
    }
    notShowLoginText() {
        this.showLogin = '';
    }

    logOut() {
        sessionStorage.clear();
        this._router.navigateByUrl('/');
    }

    getPersonalData() {
        this._router.navigateByUrl('personaldata');
    }

    getMyOrders() {
        this._router.navigateByUrl('myorders');
    }

    displayLoginMenu() {
        this.displayLogin = !this.displayLogin;
    }
}
